import { useTheme } from '@mui/material'
import { useCameraStore } from '@modugen/ui-toolkit'
import { useAppStore } from '@stores'
import { useModelStore } from '@editorStores'
import BatchedShapesMesh from './BatchedShapesMesh'
import OpeningsMesh from './OpeningsMesh'
import PositionsMesh from './PositionsMesh'
import { TensileTransmittersMesh } from './TensileTransmittersMesh'
import { VerticalTransmittersMesh } from './VerticalTransmittersMesh'

const ModelMeshV2 = () => {
  const isOrthographic = useCameraStore(state => state.isOrthographic)
  const batchedModelRenderingV2 = useAppStore(state => state.batchedModelRenderingV2)

  const { sceneOffsets } = useTheme()

  const walls = useModelStore(state => state.model.walls)
  const slabs = useModelStore(state => state.model.slabs)
  const roofSlabs = useModelStore(state => state.model.roof_slabs)
  const verticalSlabs = useModelStore(state => state.model.vertical_slabs)
  const verticalRoofSlabs = useModelStore(state => state.model.vertical_roof_slabs)

  return (
    <>
      {/* Rendered outside the perspective-only group so batched shapes stay
          visible in every camera mode, matching ModelMesh's rendering */}
      {batchedModelRenderingV2 && (
        <>
          <BatchedShapesMesh elements={walls} baseOpacity={1} includeOpenings />
          <BatchedShapesMesh elements={slabs} baseOpacity={0.9} />
          <BatchedShapesMesh elements={roofSlabs} baseOpacity={0.9} />
          <BatchedShapesMesh
            elements={verticalSlabs}
            baseOpacity={0.7}
            zOffset={sceneOffsets.verticalSlabs.z}
            polygonOffsetFactor={-1}
          />
          <BatchedShapesMesh
            elements={verticalRoofSlabs}
            baseOpacity={0.7}
            zOffset={sceneOffsets.verticalRoofSlabs.z}
            polygonOffsetFactor={-1}
          />
        </>
      )}

      <group visible={!isOrthographic}>
        <PositionsMesh />

        <VerticalTransmittersMesh disableClick={isOrthographic} />
        <TensileTransmittersMesh disableClick={isOrthographic} />
        <OpeningsMesh />
      </group>
    </>
  )
}

export { ModelMeshV2 }
